import React, { useState } from "react";
import { Layout } from "antd";
import PropTypes from "prop-types";
import ContentSider from "../../../components/templates/ContentSider";
import Surface from "../../../components/layouts/Surface";
import Spacer from "../../../components/layouts/Spacer";
import SubMenu from "../../../components/templates/SubMenu";
import { AuditOutlined } from "@ant-design/icons";
import SystemTable from "../../../components/templates/SystemTable";
import Holidays from "./holidays/Holidays";
const { Content } = Layout;

const HouseVisits = (props) => {
  const { activekey } = props;
  const [menuKey, setMenuKey] = useState("care_giver_absence_reason");

  const onMenuSelect = ({ key }) => {
    setMenuKey(key);
  };

  let ActiveComponent = null;
  switch (menuKey) {
    case "care_giver_absence_reason":
      ActiveComponent = () => (
        <SystemTable
          source="house_visits/care_giver_absence_reason"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
            { key: "is_default", type: "checkbox" },
          ]}
        />
      );
      break;

    case "other_participants":
      ActiveComponent = () => (
        <SystemTable
          source="house_visits/other_participants"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
            { key: "is_default", type: "checkbox" },
          ]}
        />
      );
      break;

    case "appearances":
      ActiveComponent = () => (
        <SystemTable
          source="house_visits/appearances"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
            { key: "is_default", type: "checkbox" },
          ]}
        />
      );
      break;

    case "nutritional_status":
      ActiveComponent = () => (
        <SystemTable
          source="house_visits/nutritional_status"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
            { key: "is_default", type: "checkbox" },
          ]}
        />
      );
      break;

    case "apartment_status":
      ActiveComponent = () => (
        <SystemTable
          source="house_visits/apartment_status"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
            { key: "is_default", type: "checkbox" },
          ]}
        />
      );
      break;

    case "significant_events":
      ActiveComponent = () => (
        <SystemTable
          source="house_visits/significant_events"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
            { key: "is_default", type: "checkbox" },
          ]}
        />
      );
      break;
    case "satisfaction_feedback":
      ActiveComponent = () => (
        <SystemTable
          source="house_visits/satisfaction_feedback"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
            { key: "is_default", type: "checkbox" },
          ]}
        />
      );
      break;

    case "house_visits_complains_feedback":
      ActiveComponent = () => (
        <SystemTable
          source="house_visits/complains_feedback"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
            { key: "is_default", type: "checkbox" },
          ]}
        />
      );
      break;

    case "house_visits_plan_hours_feedback":
      ActiveComponent = () => (
        <SystemTable
          source="house_visits/plan_hours_feedback"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
            { key: "is_default", type: "checkbox" },
          ]}
        />
      );
      break;

    default:
      ActiveComponent = () => (
        <SystemTable
          source="house_visits/care_giver_absence_reason"
          initialSorter={"name"}
          fields={[
            { key: "name", focused: true, required: true, sorter: true },
            { key: "is_default", type: "checkbox" },
          ]}
        />
      );
      break;
  }

  const items = [
    {
      name: "care_giver_absence_reason",
      category: "settings",
      icon: <AuditOutlined />,
    },
    {
      name: "other_participants",
      category: "settings",
      icon: <AuditOutlined />,
    },
    {
      name: "appearances",
      category: "settings",
      icon: <AuditOutlined />,
    },
    {
      name: "nutritional_status",
      category: "settings",
      icon: <AuditOutlined />,
    },
    {
      name: "apartment_status",
      category: "settings",
      icon: <AuditOutlined />,
    },
    {
      name: "significant_events",
      category: "settings",
      icon: <AuditOutlined />,
    },
    {
      name: "satisfaction_feedback",
      category: "settings",
      icon: <AuditOutlined />,
    },
    {
      name: "house_visits_complains_feedback",
      category: "settings",
      icon: <AuditOutlined />,
    },
    {
      name: "house_visits_plan_hours_feedback",
      category: "settings",
      icon: <AuditOutlined />,
    },
  ];

  return (
    <Layout style={{ background: "transparent", height: "100%" }}>
      <Spacer horizontal={true} smallMargin={true} />
      <ContentSider width={250}>
        <SubMenu
          onMenuSelect={onMenuSelect}
          items={items}
          selectedKeys={[menuKey]}
        />
      </ContentSider>
      <Content style={{ minHeight: 280, flex: 1 }}>
        <Surface>{activekey === "house_visits" && <ActiveComponent />}</Surface>
      </Content>
    </Layout>
  );
};

HouseVisits.propTypes = {
  mode: PropTypes.string,
};

export default HouseVisits;
